import { Component, OnInit, Optional, isDevMode } from "@angular/core";
import { AccountService } from "../../account.service";
import { NzModalRef } from "ng-zorro-antd/modal";
import { postMsg } from "@root/router/public/h5/channel/util";
import { isMobileDevice } from "@root/util/util";
import { ActivatedRoute, Router } from "@angular/router";
import { PlatformType } from "@root/config";
@Component({
  selector: "host-connect-houfy",
  templateUrl: "./connect-with-houfy.component.html",
  styleUrls: ["./connect-with-houfy.component.scss"],
})
export class V4ConnectWithHoufyComponent implements OnInit {
  footerClass = `
    fixed bottom-[20px] left-[20px] right-[20px] flex flex-col-reverse
    md:flex-row md:justify-end md:relative md:mt-12 md:bottom-0 md:left-auto md:right-0
  `;
  footerCancelBtnClass = `
    w-full
    md:mr-3 md:w-auto
  `;
  footerConfirmBtnClass = `
    w-full mb-2
    md:mb-0 md:w-auto
  `;
  step = 1;

  token;
  loading = false;

  constructor(
    @Optional() private modalRef: NzModalRef,
    private accountSrv: AccountService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {}

  private requestAuth() {
    const params = {
      username: this.token,
      hotel_id: this.token,
    };
    return this.accountSrv.accountAuth("houfy", params);
  }

  onCancel() {
    if (isMobileDevice()) {
      postMsg("BACK");
    } else {
      this.modalRef.destroy();
    }
  }

  onNext() {
    this.loading = true;
    this.requestAuth().subscribe((rst: any) => {
      this.loading = false;

      if (rst?.error_code === 0 || isDevMode()) {
        // this.step = 2;
        this.onFinish();
      }
    });
  }

  onFinish() {
    if (isMobileDevice()) {
      this.router.navigate(["../set-price-ratio"], {
        relativeTo: this.route,
        queryParams: { thirdparty_type: PlatformType.Houfy },
      });
    } else {
      this.modalRef?.destroy("success");
    }
  }
}
